import { DefaultTheme } from "styled-components";
import settings from "../settings/settings";

export const colors: any = {
  primary: settings?.colors?.light?.primary ?? "#478DF5",
  secondary: "#F5F5F7",
  tertiary: "#CCCCCC",
  lightForth: "#DEDEE2",
  forth: "#F0F0F2",
  forthOpt: "#DEDEE273",
  white: "#FFFFFF",
  black: "#000000",
  text: "rgb(0,0,0)",
  op21: "#666666",
  optBorderInput: "#66666636",
  primaryLow: "#F6FBFF",
  transparent: "transparent",
  background: "#FFFFFF",
  attNote: "#D8E7FD",
  border: "#CCCCCC80",
  primaryBorder: "#eeeeee",
  success: "#449980",
  showInfoFile: "#F0F0F0",
  error: "#EE384E",
  message: "rgba( 240, 240, 240, 60%)",
  iconColor: "#868686",
  textNotActive: "#A3A3A5",
  subBgColors: "#FFFFFF",
  inputBg: "#FFFFFF",
  medService: "#068D93",
  aiService: "#57467C",
  lifeStyleService: "#C11446",
  legalService: "#212144",
  headerInChat: "#F1F1F1",
  chatBox: "#F9F9F9",
  primaryLight: "#D8E7FD73",
  lightGreen: "#26CB63",
  red: "#E02424",
  lightRed: "#FFF2F2",
  bgDynamic: "#161616",
  legalServiceColor: "#212144",
  titleColor: "#333336",
  sendButton: "#CCCCCCCC",
  incognito: "#292D32",
  disabledIcon: "#3D3D3D",
  historyButton: "#E9E9E9",
  darkLiver: "#4F4E52",
  askQuestionButton: "#272727",
  header: "#F6F6F6",
  optTitleColor: "#33333680",
  historyHead: "#F0F0F2",
  brightGreen: "#CCFFEA",
  textGreen: "#39a062",
  brightRed: "#F7CECE",
  textRed: "#C45D5E",
  tokenIcon: "#FF980F",
  bluredBackground: "rgba(0,0,0,0.2)",
  tickIcon: "#44b449",
};

export type Colors = {
  primary: string;
  secondary: string;
  tertiary: string;
  forth: string;
  forthOpt: string;
  white: string;
  black: string;
  text: string;
  op21: string;
  optBorderInput: string;
  primaryLow: string;
  transparent: string;
  background: string;
  attNote: string;
  border: string;
  primaryBorder: string;
  success: string;
  showInfoFile: string;
  error: string;
  message: string;
  iconColor: string;
  textNotActive: string;
  subBgColors: string;
  inputBg: string;
  medService: string;
  aiService: string;
  lifeStyleService: string;
  legalService: string;
  headerInChat: string;
  chatBox: string;
  primaryLight: string;
  lightForth: string;
  lightGreen: string;
  red: string;
  lightRed: string;
  iconBg: string;
  legalServiceColor: string;
  titleColor: string;
  sendButton: string;
  disabledIcon: string;
  darkLiver: string;
  historyButton: string;
  askQuestionButton: string;
  header: string;
  optTitleColor: string;
  brightGreen: string;
  textGreen: string;
  brightRed: string;
  textRed: string;
  tokenIcon: string;
  bluredBackground: string;
  tickIcon: string;
};

export type Color = keyof Colors;
